var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResumeRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82031 12.3372V3.6646C2.82031 3.51498 2.87124 3.3896 2.97309 3.28844C3.07494 3.18729 3.20033 3.13672 3.34925 3.13672C3.49816 3.13672 3.62319 3.18729 3.72435 3.28844C3.8255 3.3896 3.87572 3.51463 3.87502 3.66354V12.3361C3.87502 12.4858 3.82444 12.6111 3.72329 12.7123C3.62214 12.8127 3.49676 12.863 3.34714 12.863C3.19752 12.863 3.07249 12.8127 2.97204 12.7123C2.87159 12.6119 2.82137 12.4865 2.82137 12.3361M7.67027 12.097C7.38648 12.2677 7.10165 12.2684 6.81576 12.0991C6.52987 11.9291 6.38692 11.6818 6.38692 11.3573V4.64344C6.38692 4.31892 6.52987 4.07166 6.81576 3.90167C7.10165 3.73309 7.38613 3.73379 7.66921 3.90378L13.2957 7.26703C13.5654 7.43983 13.7003 7.68498 13.7003 8.00248C13.7003 8.31998 13.5651 8.56372 13.2947 8.73371L7.67027 12.097Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeRounded);
export default __webpack_public_path__ + "static/media/resume-rounded.df066f33c3dd9dcaea0d6756f069a6e0.svg";
export { ForwardRef as ReactComponent };